import SnowCover from './SnowCover';
export default SnowCover;
